import wechat from "@/assets/img/wechat.png";
import alipay from "@/assets/img/alipay.png";
import unionpay from "@/assets/img/unionpay.png";
import creditDebitCard from "@/assets/img/credit-debit-card.png";
import bankTransfer from "@/assets/img/bank-transfer.png";
/**
 * 汉语符号正则
 */
export const zhCharReg =
  /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+/g;

// apc定购期刊的单价
export const apcJournalUnitPrice = 100;
export const taxRate = 0.06;

export enum PayWay {
  Wx = 1,
  Zhifubao = 2,
  Yinlian = 3,
  Offline = 4,
  Card = 5,
}

export const payWayList = {
  [PayWay.Wx]: {
    value: "微信支付",
    src: wechat,
  },
  [PayWay.Zhifubao]: {
    value: "支付宝",
    src: alipay,
  },
  [PayWay.Yinlian]: {
    value: "银联云闪付",
    src: unionpay,
  },
  [PayWay.Offline]: {
    value: "线下汇款",
    src: bankTransfer,
  },
  [PayWay.Card]: {
    value: "信用卡/借记卡",
    src: creditDebitCard,
  },
  6: {
    value: "通联支付-微信",
    src: wechat,
  },
  7: {
    value: "通联支付-支付宝",
    src: alipay,
  },
  8: {
    value: "通联支付-银联云闪付",
    src: unionpay,
  },
  9: {
    value: "通联支付-银行卡",
    src: creditDebitCard,
  },
};

/**
 * 通联二维码 pay_type。
 * 订单支付方式是 1 微信 / 2 支付宝 / 3 银联，通联接口是 1 支付宝 / 2 微信 / 3 银联。
 */
export const allInPayTypeMap: Partial<Record<PayWay, 1 | 2 | 3>> = {
  [PayWay.Zhifubao]: 1,
  [PayWay.Wx]: 2,
  [PayWay.Yinlian]: 3,
};

export enum PayResultStatus {
  // 未完成
  UnDone = 1,
  // 已完成
  Completed = 2,
  // 交易失败
  Failed = 3,
}

/**
 * 订单类型
 */
export enum SOURCE_ORDER_TYPE {
  //论文订单
  Apc = 1,
  // 会议订单
  Meeting,
  // ppv订单
  Ppv,
  // 图书订单
  Bpc,
  // pod纸本期刊订单 在订单里原订单是没有pod的 所有5是ptp
  Pod,
  // ptp订单
  Ptp,
}

// 源订单类型
export enum PUBLISHER_SOURCE_ORDER_TYPE_NUM {
  //论文订单
  Apc = 1,
  // 会议订单
  Meeting,
  // ppv订单
  Ppv,
  // 图书订单
  Bpc,
  // 纸本期刊
  Ptp,
}

// export const billTypeList = [
//   { value: 1, label: "电子增值税发票" },
//   { value: 2, label: "增值税专用发票" },
//   { value: 3, label: "电子发票（普通发票）" },
//   { value: 4, label: "电子发票（增值税专用发票）" },
// ];

export const InvoiceTypeMap = {
  1: "电子增值税发票",
  2: "增值税专用发票",
  3: "电子发票（普通发票）",
  4: "电子发票（增值税专用发票）",
};

// 发票类型，枚举值：1表示电子普通发票；2表示专用发票；3 电子发票（普通发票）4:电子发票（增值税专用发票）
export enum BillType {
  ElectronicOrdinaryInvoice = 1,
  SpecialInvoice,
  ElectronicGeneral = 3,
  ElectronicSpecial = 4,
}

// 发票状态，枚举值：1表示开票中；2表示已开票；3表示取消中；4表示已取消
export enum BillStatus {
  Invoicing = 1,
  Invoiced,
  Canceling,
  Cancelled,
}

/**
 * 发票抬头
 */
export enum TitleType {
  Company = 1,
  Personal,
  Government,
}

// 订单类型到发票内容的映射
export const OrderTypeToInvoiceContentMap = {
  1: "版面费",
  2: "会议注册费",
  3: "信息服务费",
  [SOURCE_ORDER_TYPE.Pod]: "期刊",
  [SOURCE_ORDER_TYPE.Ptp]: "版面费",
} as const;

// footer配置
export const FooterConfig = {
  kefuEmail: "publink@cnpiec.com.cn",
  kefuPhone: "18510577125 或 18510581525（微信同号） ",
  onLineTime: "工作日 09:00-17:00",
};

export enum OrderStatus {
  Unpaid = 1,
  Paid,
}

/**
 * Pod订单状态
 * 1表示待支付，2表示待处理，3表示处理中，4表示物流已发货，5表示订单已完成，6表示退款中，7表示退款完成，8表示订单已取消
 */
export enum PodOrderStatus {
  PendingPayment = 1,
  PendingProcess,
  Processing,
  Shipped,
  Completed,
  Refunding,
  RefundCompleted,
  Canceled,
}

// export const PodOrderStatusStr =  {
//   PendingPayment = 1,
//   PendingProcess,
//   Processing,
//   Shipped,
//   Completed,
//   Refunding,
//   RefundCompleted,
//   Canceled,
// }

/**
 * Pod订单状态列表
 */
export const podOrderStatusList = [
  { value: 1, label: "待支付" },
  { value: 2, label: "待处理" },
  { value: 3, label: "处理中" },
  { value: 4, label: "物流已发货" },
  { value: 5, label: "订单已完成" },
  { value: 6, label: "退款中" },
  { value: 7, label: "退款完成" },
  { value: 8, label: "订单已取消" },
];

export const podOrderStatusMap: Record<PodOrderStatus, string> = {
  [PodOrderStatus.PendingPayment]: "待支付",
  [PodOrderStatus.PendingProcess]: "待处理",
  [PodOrderStatus.Processing]: "处理中",
  [PodOrderStatus.Shipped]: "物流已发货",
  [PodOrderStatus.Completed]: "订单已完成",
  [PodOrderStatus.Refunding]: "退款中",
  [PodOrderStatus.RefundCompleted]: "退款完成",
  [PodOrderStatus.Canceled]: "订单已取消",
};

export const podNumList = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

// pod 版本类型
export enum PodVersionType {
  // 黑白版
  BlackWhite = 1,
  // 彩色版
  Color = 2,
}

// pod 版本类型对应的名称（i18n key）
export const podVersionNameMap: Record<number, string> = {
  [PodVersionType.BlackWhite]: "黑白版",
  [PodVersionType.Color]: "彩色版",
};
